'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import { HSAnalyticsContext } from './HSAnalyticsContext';

const HSAnalyticsProvider = ({
  children
}) => {
  const [initialPageLoad, setInitialPageLoad] = useState(true);
  return /*#__PURE__*/_jsx(HSAnalyticsContext.Provider, {
    value: {
      initialPageLoad,
      setInitialPageLoad
    },
    children: children
  });
};

HSAnalyticsProvider.propTypes = {
  children: PropTypes.node
};
export default HSAnalyticsProvider;